<template>
    <div id="autoresponder" class="modal inmodal fade modal-v5">
        <div class="modal-dialog">
            <div class="modal-content modal_content" v-show="!loading">
                <div class="modal_header">
                    <button type="button" class="close" @click.prevent="toggleMainModal" aria-hidden="true">&times;</button>
                    <h4 class="modal_title">
                        {{view.translations.funnel_tab_autoresponder}}
                    </h4>
                    <fs5-collapse-info :view="[view.translations.maillingboss_setup, view.translations.autoresponder_maillingboss_setup_helper]"></fs5-collapse-info>
                    <!-- <div class="subtitile_box">
                        <span class="modal_subtitle">
                            {{view.translations.maillingboss_setup}}
                        </span>
                    </div> -->
                </div>
                <div class="modal-body">
                    <autoresponder-v4
                        :phpprops="view"
                        :toggleMainModal="toggleMainModal"
                        @closeModal="closeModal"
                        @saveData="saveData"
                    ></autoresponder-v4>
                </div>
            </div>
            <div class="modal-content modal_content" v-show="loading">
                <div class="modal-header">
                     <button type="button" class="close" @click.prevent="toggleMainModal" aria-hidden="true">&times;</button>
                </div>
                <div class="modal-body text-center">
                    <img class="modal-loader" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        name: 'autoresponder-v5',
        data: function() {
            return {
                //data
                lang: window.lang || 'us',
                loading: true,
                view: { // prevent undefined bugs
                    data: {
                        dados_usuario_office: {},
                        mb_tutorial_video: ''
                    },
                    routes: {
                        rota_office_franchise_system_list_mb: '',
                        rota_office_handler_usuarios_complement: '',
                        rota_office_mailingboss_home: ''
                    },
                    translations: {
                        autoresponder_connect_mb: '',
                        autoresponder_opt_dont_want_followup: '',
                        autoresponder_opt_export_leads: '',
                        autoresponder_opt_want_followup: '',
                        autoresponder_step: '',
                        button_salvar: '',
                        click_here: '',
                        click_here_connect_mb_list: '',
                        funnel_tab_autoresponder: '',
                        here: '',
                        inside_mb_account: '',
                        login_mb_create_list: '',
                        login_to: '',
                        maillingboss_setup: '',
                        office2_autopilot_rede_register_list_label: '',
                        office2_autopilot_rede_register_list_title: '',
                        office2_share_landingpage_passo3_criar_lista: '',
                        option_above: '',
                        processing: '',
                        select_mb_list_option: '',
                        start_watching_tutorial_ar: '',
                        watch_video_tutorial: ''
                    }
                }
            }
        },
        methods: {
            init: async function (){
                await this.requestAutoresponder()
            },
            toggleMainModal() {
                this.$emit('toggleAutoresponder')
                $('#autoresponder').trigger( "toggleAutoresponder")
            },
            requestAutoresponder: async function (){
                this.loading = true
                try{
                    let res = await axios.get(`/${this.lang}/office/franchise-system/autoresponder/data`)
                    res = res.data.data
                    this.$set(this.$data, 'view', res)
                } catch(e) {
                    console.log('error = ', e.getMessage())
                } finally {
                    this.loading = false
                }

            },
            closeModal(){
                this.toggleMainModal()
            },
            saveData(){
                // mantem fechado
            }
        },
        created(){
        },
        mounted(){
            $('#autoresponder').on('show.bs.modal', this.init)
            // $('#registerListMailingBossModal').on('hidden.bs.modal', this.toggleMainModal);
        }
    }
</script>

<style scoped lang="scss">
.modal_content {
    border: 1px solid #C9E4FF !important;
    border-radius: 8px !important;
    width: 100%;

    .modal_header {
        .modal_title {
            font-family: 'Lato';
            font-weight: bold;
            font-size: 29px;

            text-transform: uppercase;

            color: #A5B9D5;
        }
        .subtitile_box {
            padding: .5rem 1rem !important;
            width: 100% !important;
            background: #E9EDF2 !important;
            border-radius: 5px !important;

            .modal_subtitle {
                font-family: 'Lato';
                font-weight: bold;
                font-size: 15px;

                text-transform: uppercase;

                display: flex;
                align-items: center;

                color: #A5B9D5;
            }
        }
    }
    .modal-body {
        padding: 2rem 0 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/modals/Autoresponder.vue